import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SignIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7 12.7C7 12.5895 7.08954 12.5 7.2 12.5H8.8C8.91046 12.5 9 12.5895 9 12.7V14.5C9 15.0523 8.55229 15 8 15C7.44772 15 7 15.0523 7 14.5V12.7Z"
		/>
		<path
			fill="currentColor"
			d="M6.99998 1.5C6.99998 0.992531 7.37798 0.995479 7.86777 0.9993C7.91103 0.999637 7.95516 0.999981 7.99998 0.999981C8.04479 0.999981 8.08892 0.999637 8.13218 0.9993C8.62198 0.995479 8.99999 0.992531 8.99999 1.5V2.3C8.99999 2.41046 8.91043 2.5 8.79998 2.5H7.19998C7.08952 2.5 6.99998 2.41046 6.99998 2.3V1.5Z"
		/>
		<path
			fill="currentColor"
			d="M13 11.36C13 11.584 13 11.696 12.9564 11.7816C12.918 11.8569 12.8568 11.9181 12.7816 11.9564C12.696 12 12.584 12 12.36 12H3.24741C3.15592 12 3.11018 12 3.06681 11.9902C3.02835 11.9816 2.99138 11.9673 2.9571 11.9478C2.91845 11.9259 2.8846 11.8951 2.8169 11.8336L1.3209 10.4736C1.14031 10.3094 1.05002 10.2273 1.01663 10.1308C0.987295 10.0461 0.987295 9.95393 1.01663 9.86917C1.05002 9.7727 1.14031 9.69061 1.3209 9.52644L2.8169 8.16644C2.8846 8.10489 2.91845 8.07412 2.9571 8.05217C2.99138 8.03271 3.02835 8.01841 3.06681 8.00976C3.11018 8 3.15592 8 3.24741 8H12.36C12.584 8 12.696 8 12.7816 8.0436C12.8568 8.08195 12.918 8.14314 12.9564 8.2184C13 8.30397 13 8.41598 13 8.64V11.36Z"
		/>
		<path
			fill="currentColor"
			d="M3.04357 3.2184C2.99998 3.30397 2.99998 3.41598 2.99998 3.64V6.36C2.99998 6.58402 2.99998 6.69603 3.04357 6.7816C3.08192 6.85686 3.14311 6.91805 3.21838 6.9564C3.30394 7 3.41595 7 3.63998 7H12.7526C12.844 7 12.8898 7 12.9332 6.99024C12.9716 6.98159 13.0086 6.96729 13.0429 6.94783C13.0815 6.92588 13.1154 6.89511 13.1831 6.83357L14.6791 5.47356C14.8597 5.30939 14.95 5.2273 14.9833 5.13082C15.0127 5.04607 15.0127 4.95392 14.9833 4.86917C14.95 4.7727 14.8597 4.69061 14.6791 4.52644L13.1831 3.16644C13.1154 3.1049 13.0815 3.07412 13.0429 3.05217C13.0086 3.03271 12.9716 3.01841 12.9332 3.00976C12.8898 3 12.844 3 12.7526 3H3.63998C3.41595 3 3.30394 3 3.21838 3.0436C3.14311 3.08195 3.08192 3.14314 3.04357 3.2184Z"
		/>
	</svg>
))
